export default __webpack_public_path__ + "static/media/add-external.615e961f.svg";